/* Kick Frame — "View in 3D": de poster als ingelijst object dat je met vinger of muis draait.
   Alleen CSS 3D-transforms, geen externe bibliotheek. Wordt geladen op productpagina's. */
(function () {
  var gallery = document.querySelector('.gallery-main');
  if (!gallery) return;
  var firstThumb = document.querySelector('.thumbs .thumb');
  var mainImg = gallery.querySelector('img');
  var src = (firstThumb && firstThumb.getAttribute('data-full')) || (mainImg && mainImg.currentSrc) || '';
  if (!src) return;

  var css = ''
    + '.kf3d-open{position:absolute;right:.75rem;bottom:.75rem;z-index:3;display:inline-flex;align-items:center;gap:.4rem;'
    + 'padding:.55rem .9rem;border:1px solid rgba(255,255,255,.35);border-radius:999px;background:rgba(10,20,16,.72);'
    + 'color:#fff;font:600 .85rem/1 inherit;letter-spacing:.02em;cursor:pointer;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px)}'
    + '.kf3d-open:hover{background:var(--green,#2f8f5b);border-color:transparent}'
    + '.kf3d-open svg{width:18px;height:18px}'
    + '.kf3d{position:fixed;inset:0;z-index:1000;display:flex;align-items:center;justify-content:center;'
    + 'background:radial-gradient(120% 90% at 50% 30%,#23392f 0%,#0c1511 70%);opacity:0;transition:opacity .3s}'
    + '.kf3d.is-open{opacity:1}'
    + '.kf3d-stage{perspective:1400px;width:min(78vw,56vh);aspect-ratio:3/4;touch-action:none;cursor:grab}'
    + '.kf3d-stage:active{cursor:grabbing}'
    + '.kf3d-obj{position:relative;width:100%;height:100%;transform-style:preserve-3d;will-change:transform}'
    + '.kf3d-face{position:absolute;inset:0;backface-visibility:hidden;-webkit-backface-visibility:hidden}'
    + '.kf3d-front{background:#111;padding:4.5%;box-shadow:inset 0 0 0 1px #000;transform:translateZ(var(--d))}'
    + '.kf3d-front img{display:block;width:100%;height:100%;object-fit:cover;box-shadow:0 0 0 1px rgba(0,0,0,.6)}'
    + '.kf3d-glare{position:absolute;inset:0;pointer-events:none;mix-blend-mode:screen;'
    + 'background:linear-gradient(var(--ga,115deg),rgba(255,255,255,0) 30%,rgba(255,255,255,.22) 48%,rgba(255,255,255,0) 62%);'
    + 'background-size:220% 220%;background-position:var(--gx,50%) 50%}'
    + '.kf3d-back{background:#6b5a45;transform:rotateY(180deg) translateZ(var(--d))}'
    + '.kf3d-side{position:absolute;background:linear-gradient(90deg,#1b1b1b,#070707)}'
    + '.kf3d-l,.kf3d-r{top:0;height:100%;width:calc(var(--d) * 2);left:50%;margin-left:calc(var(--d) * -1)}'
    + '.kf3d-t,.kf3d-b{left:0;width:100%;height:calc(var(--d) * 2);top:50%;margin-top:calc(var(--d) * -1)}'
    + '.kf3d-l{transform:rotateY(-90deg) translateZ(calc(var(--w) / 2))}'
    + '.kf3d-r{transform:rotateY(90deg) translateZ(calc(var(--w) / 2))}'
    + '.kf3d-t{transform:rotateX(90deg) translateZ(calc(var(--h) / 2))}'
    + '.kf3d-b{transform:rotateX(-90deg) translateZ(calc(var(--h) / 2))}'
    + '.kf3d-shadow{position:absolute;left:8%;right:8%;bottom:-9%;height:8%;border-radius:50%;'
    + 'background:rgba(0,0,0,.55);filter:blur(18px);transform:translateZ(-60px)}'
    + '.kf3d-close{position:absolute;top:1rem;right:1rem;width:44px;height:44px;border-radius:50%;border:1px solid rgba(255,255,255,.3);'
    + 'background:rgba(0,0,0,.35);color:#fff;font-size:1.5rem;line-height:1;cursor:pointer}'
    + '.kf3d-hint{position:absolute;bottom:max(1.25rem,env(safe-area-inset-bottom));left:0;right:0;text-align:center;'
    + 'color:rgba(255,255,255,.7);font-size:.85rem;letter-spacing:.04em}'
    + '@media (prefers-reduced-motion:reduce){.kf3d{transition:none}}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'kf3d-open';
  btn.setAttribute('aria-label', 'View this poster in 3D');
  btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<path d="M12 2 3 7v10l9 5 9-5V7z"/><path d="M3 7l9 5 9-5M12 12v10"/></svg>View in 3D';
  gallery.appendChild(btn);

  var overlay, obj, raf, rx = -6, ry = -18, vx = 0, vy = 0, dragging = false, lastX = 0, lastY = 0, idle = 0, t0 = 0;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'kf3d';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Poster in 3D');
    overlay.innerHTML = '<div class="kf3d-stage"><div class="kf3d-obj">'
      + '<div class="kf3d-shadow"></div>'
      + '<div class="kf3d-face kf3d-back"></div>'
      + '<div class="kf3d-side kf3d-l"></div><div class="kf3d-side kf3d-r"></div>'
      + '<div class="kf3d-side kf3d-t"></div><div class="kf3d-side kf3d-b"></div>'
      + '<div class="kf3d-face kf3d-front"><img alt="" draggable="false"><div class="kf3d-glare"></div></div>'
      + '</div></div>'
      + '<button type="button" class="kf3d-close" aria-label="Close">&times;</button>'
      + '<p class="kf3d-hint">Drag to rotate</p>';
    overlay.querySelector('img').src = src;
    obj = overlay.querySelector('.kf3d-obj');
    var stage = overlay.querySelector('.kf3d-stage');
    overlay.querySelector('.kf3d-close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    stage.addEventListener('pointerdown', function (e) {
      dragging = true; lastX = e.clientX; lastY = e.clientY; vx = vy = 0;
      stage.setPointerCapture(e.pointerId);
    });
    stage.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - lastX, dy = e.clientY - lastY;
      lastX = e.clientX; lastY = e.clientY;
      vy = dx * 0.45; vx = -dy * 0.3;
      ry += vy; rx += vx;
      idle = 0;
    });
    function up() { dragging = false; }
    stage.addEventListener('pointerup', up);
    stage.addEventListener('pointercancel', up);
  }

  function size() {
    var r = obj.getBoundingClientRect();
    var w = obj.offsetWidth, h = obj.offsetHeight;
    obj.style.setProperty('--w', w + 'px');
    obj.style.setProperty('--h', h + 'px');
    obj.style.setProperty('--d', Math.round(w * 0.035) + 'px');
  }

  function frame(t) {
    if (!t0) t0 = t;
    if (!dragging) {
      vx *= 0.92; vy *= 0.92;
      ry += vy; rx += vx;
      idle++;
      if (idle > 40 && !reduce) {
        // zacht heen en weer wiegen als niemand sleept
        var s = (t - t0) / 1000;
        ry += ((-18 + Math.sin(s * 0.8) * 22) - ry) * 0.02;
        rx += ((-6 + Math.sin(s * 0.6) * 4) - rx) * 0.02;
      }
    }
    rx = Math.max(-35, Math.min(35, rx));
    obj.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
    var norm = ((ry % 360) + 360) % 360;
    obj.style.setProperty('--gx', (50 + Math.sin(norm * Math.PI / 180) * 45).toFixed(1) + '%');
    raf = requestAnimationFrame(frame);
  }

  function onKey(e) { if (e.key === 'Escape') close(); }

  function open() {
    if (!overlay) build();
    document.body.appendChild(overlay);
    document.documentElement.style.overflow = 'hidden';
    size();
    rx = -6; ry = -38; vx = 0; vy = 1.2; idle = 0; t0 = 0;
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    raf = requestAnimationFrame(frame);
    window.addEventListener('resize', size);
    document.addEventListener('keydown', onKey);
    overlay.querySelector('.kf3d-close').focus();
  }

  function close() {
    cancelAnimationFrame(raf);
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    window.removeEventListener('resize', size);
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 300);
    btn.focus();
  }

  btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); open(); });
})();
